const imageData = [
  {
    src: "/images/elegant-bengali-woman-red-saree-portrait.jpg",
    alt: "Elegant Bengali Woman",
    category: "Human"
  },
  {
    src: "/images/girl-with-sunflower-bouquet-smiling-portrait-street-market-mayachitro.jpg",
    alt: "Girl with Sunflower Bouquet",
    category: "Human"
  },
  {
  src: "/images/Serene_Bangladeshi_Girl_Lakeside_Portrait.jpg",
  alt: "Serene Bangladeshi Girl Lakeside Portrait",
  category: "Human"
},
  {
    src: "/images/flower-seller-portrait-maroon-celosia-market-mayachitro.jpg",
    alt: "Flower Seller Portrait",
    category: "Human"
  },
  {
    src: "/images/dramatic-bokeh-portrait-bengali-woman-black-dress-warm-lights-mayachitro.jpg",
    alt: "Dramatic Bokeh Portrait Bengali",
    category: "Human"
  },
  {
    src: "/images/bengali-woman-admires-flowers-red-saree-portrait-soft-bokeh-mayachitro.jpg",
    alt: "Bengali Woman in Red Saree Admiring Flowers",
    category: "Human"
  },
  {
    src: "/images/woman-in-saree-looking-at-flowers-portrait.jpg",
    alt: "Woman Looking at Flowers",
    category: "Human"
  },
  {
    src: "/images/woman-in-saree-with-elephant-print-garden-portrait.jpg",
    alt: "Woman with Elephant Print Saree",
    category: "Human"
  },
  {
    src: "/images/smiling-woman-black-dress-glasses-portrait-garden-movement-mayachitro.jpg",
    alt: "Smiling Woman Black Dress Glasses",
    category: "Human"
  },
  {
    src: "/images/smiling-bengali-girl-holding-yellow-white-flower-bouquet-street-portrait-mayachitro.JPG",
    alt: "Smiling Bengali Girl Holding Flower Bouquet",
    category: "Human"
  },
  {
    src: "/images/smiling-bengali-woman-flowing-hair-red-saree-portrait-movement-mayachitro.jpg",
    alt: "Bengali Woman in Red Saree with Flowing Hair Looking Back",
    category: "Human"
  },
  {
    src: "/images/woman-under-tree-lights-evening-portrait.jpg",
    alt: "Woman Under Tree Lights",
    category: "Human"
  },
  {
    src: "/images/elegant-indian-woman-red-saree-curly-hair-portrait-look-up-expression-mayachitro.jpg",
    alt: "Elegant Indian Woman",
    category: "Human"
  },
  {
    src: "/images/emotional-child-portrait-holding-goat-black-and-white-photo-mayachitro.jpg",
    alt: "Child Holding Goat",
    category: "Human"
  },
  {
    src: "/images/street-flute-seller-old-man-sitting-indian-market-night-portrait-mayachitro.JPG",
    alt: "Old Man Selling Flutes at Indian Market Street Portrait",
    category: "Human"
  },
  {
    src: "/images/silhouette-man-watching-red-sunset-sea-beach-minimalist-moodscape-mayachitro.jpg",
    alt: "Man Watching Red Sunset on Sea Beach Silhouette Moodscape",
    category: "Human"
  },
{
  src: "/images/bangladeshi-man-colorful-panjabi-street-portrait-traditional-cap-cultural-festival-mayachitro.jpg",
  alt: "Colorful Panjabi Man Street Portrait",
  category: "Human"
},
{
  src: "/images/bengali-woman-closeup-curly-hair-bold-look-traditional-beauty-portrait-mayachitro.jpg",
  alt: "Bengali Woman Closeup with Curly Hair",
  category: "Human"
},
{
  src: "/images/bengali-woman-in-black-maroon-saree-traditional-look-with-jewelry-in-garden-light-mayachitro.jpg",
  alt: "Bengali Woman in Black Maroon Saree with Jewelry",
  category: "Human"
},
{
  src: "/images/bengali-woman-in-traditional-saree-looking-up-under-lamp-evening-vibes-mayachitro.jpg",
  alt: "Bengali Woman Looking Up Under Lamp",
  category: "Human"
},
{
  src: "/images/bengali-woman-portrait-blue-dress-pink-rose-natural-light-outdoor-photography-mayachitro.jpg",
  alt: "Bengali Woman Blue Dress with Pink Rose",
  category: "Human"
},
{
  src: "/images/bengali-woman-red-black-saree-traditional-indoor-portrait-flower-bowl-mood-lighting-mayachitro.jpg",
  alt: "Bengali Woman in Red Black Saree with Flower Bowl",
  category: "Human"
},
{
  src: "/images/bengali-woman-red-saree-traditional-jewelry-fashion-portrait-curly-hair-mayachitro.jpg",
  alt: "Bengali Woman Red Saree Curly Hair Fashion Portrait",
  category: "Human"
},
{
  src: "/images/bengali-woman-red-striped-dress-stylish-outdoor-portrait-beauty-glance-mayachitro.jpg",
  alt: "Bengali Woman Red Striped Dress Outdoor Portrait",
  category: "Human"
},
{
  src: "/images/bengali-woman-red-white-saree-full-portrait-festival-look-pohela-boishakh-style-mayachitro.jpg",
  alt: "Bengali Woman Red White Saree Festival Portrait",
  category: "Human"
},
{
  src: "/images/bengali-woman-red-white-saree-smile-mehndi-portrait-pohela-boishakh-cultural-festival-mayachitro.jpg",
  alt: "Smiling Bengali Woman Red White Saree with Mehndi",
  category: "Human"
},
{
  src: "/images/bengali-woman-sitting-cafe-garden-black-red-saree-traditional-style-outdoor-portrait-mayachitro.jpg",
  alt: "Bengali Woman Sitting in Garden in Black Red Saree",
  category: "Human"
},
{
  src: "/images/bengali-woman-traditional-red-black-saree-portrait-garden-look.jpg",
  alt: "Traditional Bengali Woman in Red Black Saree",
  category: "Human"
},
{
  src: "/images/elegant-bengali-woman-red-saree-traditional-portrait-curly-hair-beauty-mayachitro.jpg",
  alt: "Elegant Bengali Woman in Red Saree with Curly Hair",
  category: "Human"
},
{
  src: "/images/elegant-woman-in-black-saree-traditional-bengali-attire-under-hanging-lamp-mayachitro.jpg",
  alt: "Elegant Woman in Black Saree Under Hanging Lamp",
  category: "Human"
},
{
  src: "/images/muslim-woman-hijab-portrait-nature-sitting-in-grass-outdoor-thoughtful-look-mayachitro.jpg",
  alt: "Muslim Woman in Hijab Sitting Thoughtfully in Nature",
  category: "Human"
},
{
  src: "/images/muslim-boy-playing-beach-sea-water-blue-kurta-coxsbazar-mayachitro.jpg",
  alt: "Muslim Boy Playing at Beach in Blue Kurta",
  category: "Human"
},
{
  src: "/images/rose-seller-old-man-flower-market-dhaka-portrait-street-photography-mayachitro.jpg",
  alt: "Rose Seller Old Man at Flower Market Dhaka",
  category: "Human"
},
{
  src: "/images/chicken-seller-on-bicycle-old-man-urban-street-life-portrait-dhaka-mayachitro.jpg",
  alt: "Chicken Seller on Bicycle Urban Dhaka",
  category: "Human"
},
{
  src: "/images/disabled-man-begging-crowded-street-night-life-contrast-emotion-dhaka-mayachitro.jpg",
  alt: "Disabled Man Begging on Dhaka Street at Night",
  category: "Human"
},
{
  src: "/images/street-flute-seller-old-man-sitting-indian-market-night-portrait-mayachitro.JPG",
  alt: "Street Flute Seller Old Man Portrait at Night",
  category: "Human"
},
{
  src: "/images/solitary-sleeper-under-bare-tree-foggy-field-winter-morning-dhaka-street-photo-mayachitro.jpg",
  alt: "Solitary Sleeper under Tree on Foggy Morning",
  category: "Human"
},
{
  src: "/images/fisherman-and-wife-on-wooden-boat-bangladesh-river-life-mayachitro.jpg",
  alt: "Fisherman and Wife on Boat in Bangladesh River Life",
  category: "Human"
},

{
  src: "/images/silhouette-woman-window-gesture-traditional-dress-soft-light-portrait-mayachitro.jpg",
  alt: "Silhouette Woman by Window in Traditional Dress",
  category: "Human"
},
{
  src: "/images/street-balloon-vendor-dhaka-crowd-colorful-festival-moment-mayachitro.jpg",
  alt: "Street Balloon Vendor in Dhaka Festival Crowd",
  category: "Human"
},
{
  src: "/images/street-balloon-seller-colorful-smile-balloons.jpg",
  alt: "Street Balloon Seller with Colorful Balloons",
  category: "Human"
},
{
  src: "/images/solitary-sleep-under-winter-tree-kolkata-field-life-mayachitro.jpg",
  alt: "Solitary Person Sleeping Under Tree in Kolkata",
  category: "Human"
},
{
  src: "/images/woman-in-saree-book-cafe-evening-serenity-bengali-tradition-mayachitro.jpg",
  alt: "Woman in Saree at Book Cafe During Evening",
  category: "Human"
},
{
  src: "/images/life-on-the-edge-street-photo.jpg",
  alt: "Life on the Edge Street Photography",
  category: "Human"
},
{
  src: "/images/street-light-vendor-portrait-dhaka-night-market-smiling-man-glow-mayachitro.jpg",
  alt: "Street Light Vendor Portrait at Dhaka Night Market",
  category: "Human"
},
{
  src: "/images/happy-child-holding-colorful-fairy-light-bottle-toys-street-vendor-bokeh-mayachitro.jpg",
  alt: "Happy Child Holding Colorful Fairy Light Bottle Toy",
  category: "Human"
},



  ////////////////// Nature /////////////////////////////////////////////
  {
    src: "/images/misty-mountain-valley-path-sunrise-greenery-nature-hike-mayachitro.jpg",
    alt: "Misty Mountain Valley",
    category: "Nature"
  },
  {
    src: "/images/ants-on-cracked-soil-vs-plant-wall-texture-mayachitro.jpg",
    alt: "Ants on Soil",
    category: "Nature"
  },
  {
    src: "/images/tropical-river-hill-view.jpg",
    alt: "River Hill View",
    category: "Nature"
  },
  {
    src: "/images/tranquil-coastal-sunset-silhouette.jpg",
    alt: "Tranquil Coastal Sunset",
    category: "Nature"
  },
  {
    src: "/images/tranquil-boat-river-reflection-skylandscape-mayachitro.jpg",
    alt: "Tranquil Boat River",
    category: "Nature"
  },
  {
    src: "/images/wild-melastoma-purple-flower-closeup-forest-greenery-mayachitro.jpg",
    alt: "Wild Melastoma Flower",
    category: "Nature"
  },
  {
    src: "/images/half-colored-leaf-closeup-black-green-tones-nature-pattern-mayachitro.jpg",
    alt: "Half-Colored Leaf",
    category: "Nature"
  },
  {
    src: "/images/misty-jungle-river-path-serene-forest-morning-mayachitro.jpg",
    alt: "Misty Jungle River",
    category: "Nature"
  },
  {
    src: "/images/symmetrical-green-leaf-macro-closeup-dark-botanical-mayachitro.jpg",
    alt: "Symmetrical Green Leaf",
    category: "Nature"
  },
  {
  src: "/images/unrays-through-forest-canopy-woman-silhouette-nature-hike-mayachitro.jpg",
  alt: "Woman Silhouette Under Forest Canopy with Sun Rays",
  category: "Nature"
},
{
  src: "/images/misty-mountain-sunlight.jpg",
  alt: "Misty Mountain with Morning Sunlight",
  category: "Nature"
},
{
  src: "/images/woman-in-red-sari-posing-on-rock-waterfall-nature-travel-mayachitro.jpg",
  alt: "Woman in Red Sari Posing on Rock Near Waterfall",
  category: "Nature"
},
{
  src: "/images/yellow-rose-market-bundle-mayachitro.jpg",
  alt: "Yellow Rose Market Bundle",
  category: "Nature"
},
{
  src: "/images/misty-river-horizon-birds-flying-mountain-background-mayachitro.jpg",
  alt: "Misty River Horizon with Birds and Mountains",
  category: "Nature"
},
{
  src: "/images/black-headed-gull-flying-over-sea-closeup-bird-motion-mayachitro.jpg",
  alt: "Black-headed Gull Flying Over Sea",
  category: "Nature"
},
{
  src: "/images/lone-boatman-river-serenity-landscape-mayachitro.jpg",
  alt: "Lone Boatman in Serene River Landscape",
  category: "Nature"
},



  {
    src: "/images/sunset-bird-silhouette-over-river.jpg",
    alt: "Sunset Bird Silhouette",
    category: "Sunset"
  },
  {
    src: "/images/sunset-over-river-ship-reflection-orange-glow-mayachitro.jpg",
    alt: "Sunset Over River Ships",
    category: "Sunset"
  },
  {
    src: "/images/sunset-over-harbor-boats-glowing-water-cityscape-golden-hour-mayachitro.jpg",
    alt: "Sunset Over Harbor Boats",
    category: "Sunset"
  },
  {
    src: "/images/urban-sunset-perspective-road-lamp-posts-evening-glow-mayachitro.jpg",
    alt: "Urban Sunset Perspective",
    category: "Sunset"
  },
  {
    src: "/images/sunset-through-tree-branches-silhouette-nature-frame-mayachitro.jpg",
    alt: "Sunset Tree Silhouette",
    category: "Sunset"
  },
  {
    src: "/images/sunset-ocean-wave-shore.jpg",
    alt: "Ocean Shore Sunset",
    category: "Sunset"
  },
  {
    src: "/images/sunlight-on-ocean-waves-closeup-golden-hour-mayachitro.jpg",
    alt: "Sunlight on Ocean Waves",
    category: "Sunset"
  },
  {
    src: "/images/golden-hour-canoe-river-reflection-dramatic-clouds-mayachitro.jpg",
    alt: "Golden Hour Canoe",
    category: "Sunset"
  },
  {
    src: "/images/golden-sunset-over-ocean-waves-beach-horizon-glow-mayachitro.jpg",
    alt: "Golden Sunset Ocean",
    category: "Sunset"
  },
  {
    src: "/images/sunset-birds-over-sea-golden-light-orange-horizon-mayachitro.jpg",
    alt: "Sunset Birds Over Sea",
    category: "Sunset"
  },
  {
    src: "/images/sunset-reflection-river-boat-silhouette-orange-glow-mayachitro.jpg",
    alt: "River Boat Silhouette Sunset",
    category: "Sunset"
  },
  {
    src: "/images/tranquil-sea-sunset-boat-silhouette-minimalist-ocean-view-mayachitro.jpg",
    alt: "Tranquil Sea Sunset",
    category: "Sunset"
  },
  {
  src: "/images/sunset-boat-river-cityscape.jpg",
  alt: "Sunset Boat on River Cityscape View",
  category: "Sunset"
},
{
  src: "/images/golden-sunset-river-mountains.jpg",
  alt: "Golden Sunset Over River and Mountains",
  category: "Sunset"
},
{
  src: "/images/sunset-over-ocean-golden-reflection-sea-waves-beach-horizon-nature-mayachitro.jpg",
  alt: "Sunset Over Ocean with Golden Reflections",
  category: "Sunset"
},
{
  src: "/images/sunset-over-sea-minimal-beach-horizon-orange-sky-nature-landscape-mayachitro.jpg",
  alt: "Sunset Over Sea with Minimalist Orange Horizon",
  category: "Sunset"
},



  {
  src: "/images/flying-pigeons-riverbank-motion-wings-flock-birds-urban-nature-mayachitro.jpg",
  alt: "Flying Pigeons Over Riverbank in Motion",
  category: "Nature"
},
{
  src: "/images/golden-sunset-reflection-sea-waves-ocean-beach-horizon-nature-photography-mayachitro.jpg",
  alt: "Golden Sunset Reflection on Ocean Waves",
  category: "Nature"
},
{
  src: "/images/purple-petunia-flowers-closeup-garden-photography.jpg",
  alt: "Purple Petunia Flowers Closeup",
  category: "Nature"
},
{
  src: "/images/pink-blossoms-flower-closeup-bokeh-nature-garden-spring-photography-mayachitro.jpg",
  alt: "Pink Blossoms Flower Closeup in Garden",
  category: "Nature"
},
{
  src: "/images/marigold-garland-seller-flower-market-dhaka-traditional-street-life-mayachitro.jpg",
  alt: "Marigold Garland Seller at Dhaka Flower Market",
  category: "Nature"
},
{
  src: "/images/traditional-bengali-woman-black-maroon-saree-nature-portrait-mayachitro.jpg",
  alt: "Bengali Woman in Black Maroon Saree in Nature",
  category: "Nature"
},
{
  src: "/images/muslim-woman-hijab-portrait-nature-sitting-in-grass-outdoor-thoughtful-look-mayachitro.jpg",
  alt: "Muslim Woman in Hijab Sitting in Nature",
  category: "Nature"
},
{
  src: "/images/pink-purple-aster-bouquet-closeup-flower-market-color-burst-mayachitro.jpg",
  alt: "Pink Purple Aster Bouquet Closeup at Flower Market",
  category: "Nature"
},
{
  src: "/images/deep-pink-frangipani-flower-closeup-garden-bokeh-tropical-bloom-mayachitro.jpg",
  alt: "Deep Pink Frangipani Flower Closeup in Garden",
  category: "Nature"
},

  // Urban
  {
    src: "/images/urban-night-rain-reflection-street-lights-cityscape-mayachitro.jpg",
    alt: "Rainy Night Cityscape",
    category: "Urban"
  },
  {
    src: "/images/urban-highway-intersection-aerial.jpg",
    alt: "City Highway",
    category: "Urban"
  },
  {
    src: "/images/urban-night-rainy-road-long-exposure-lighttrails-mayachitro.jpg",
    alt: "Urban Rainy Road Trails",
    category: "Urban"
  },
  {
    src: "/images/vibrant-night-lamp-market-bazaar.jpg",
    alt: "Vibrant Night Market",
    category: "Urban"
  },
  {
    src: "/images/neon-bridge-night-reflection.jpg",
    alt: "Neon Bridge Night",
    category: "Urban"
  },
  {
    src: "/images/bokeh-abstract-shopping-mall-dome-interior-lights-artistic-blur-mayachitro.jpg",
    alt: "Bokeh Mall Dome",
    category: "Urban"
  },
  {
    src: "/images/dhaka-city-night-traffic-lighttrails-rainy-road-longexposure-mayachitro.jpg",
    alt: "Dhaka Night Traffic",
    category: "Urban"
  },
  {
    src: "/images/moonlit-urban-road-lighttrails-street-tree-cloudy-sky-nightscape-mayachitro.jpg",
    alt: "Urban Road Lighttrails",
    category: "Urban"
  },
  {
    src: "/images/urban-cyclist-evening-sky-rays-over-highrise-city-bridge-mayachitro.jpg",
    alt: "Cyclist and Evening Sky",
    category: "Urban"
  },
  {
    src: "/images/vibrant-urban-sunset-skyline-colored-clouds-evening-view-mayachitro.jpg",
    alt: "Urban Sunset Skyline",
    category: "Urban"
  },
{
  src: "/images/dhaka-night-long-exposure-traffic-trails-metro-rail-cityscape.jpg",
  alt: "Dhaka Night Long Exposure Traffic Metro Rail Cityscape",
  category: "Urban"
},
{
  src: "/images/dhaka-river-commute-wooden-boats-people-transport-lifestyle-mayachitro.jpg",
  alt: "Dhaka River Commute with Wooden Boats and People",
  category: "Urban"
},
{
  src: "/images/kolkata-yellow-taxi-driver-night.jpg",
  alt: "Kolkata Yellow Taxi Driver at Night",
  category: "Urban"
},
{
  src: "/images/colorful-night-market-dhaka-cityscape-tents-lights-festival-photography-mayachitr.jpg",
  alt: "Colorful Night Market in Dhaka with Cityscape Tents and Lights",
  category: "Urban"
},
{
  src: "/images/balloon-vendor-city-motion-long-exposure-mayachitro.jpg",
  alt: "Balloon Vendor City Motion in Long Exposure",
  category: "Urban"
},
{
  src: "/images/urban-sunset-highrise-buildings-riverside-fair-evening-cityscape-mayachitro.jpg",
  alt: "Urban Sunset Over Riverside Highrises and Fair",
  category: "Urban"
},
{
  src: "/images/street-food-dhaka-boy-selling-boiled-eggs-night-market.jpg",
  alt: "Street Food Boy Selling Boiled Eggs at Dhaka Night Market",
  category: "Urban"
},
{
  src: "/images/bougainvillea-street-scene-dhaka.jpg",
  alt: "Bougainvillea on Street in Dhaka",
  category: "Urban"
},
{
  src: "/images/colorful-balloons-night-dhaka-street-photography.jpg",
  alt: "Colorful Balloons at Night in Dhaka",
  category: "Urban"
},
{
  src: "/images/bougainvillea-bloom-urban-architecture-bokeh-photography-mayachitro.jpg",
  alt: "Bougainvillea Bloom with Urban Architecture in Background",
  category: "Urban"
},
{
  src: "/images/colorful-smiley-balloons-street-vendor-dhaka-crowd-portrait-urban-life-mayachitro.jpg",
  alt: "Colorful Smiley Balloons Street Vendor in Dhaka",
  category: "Urban"
},
{
  src: "/images/colorful-balloons-street-vendor.jpg",
  alt: "Colorful Balloons with Street Vendor",
  category: "Urban"
},
{
  src: "/images/man-silhouette-city-lights-bokeh-night-contemplation-street-photography-dhaka-mayachitro.jpg",
  alt: "Man Silhouette in City Lights Bokeh at Night",
  category: "Urban"
},
{
  src: "/images/street-cat-portrait-bokeh-lights-evening-vibe-mayachitro.jpg",
  alt: "Street Cat Portrait with Bokeh Lights in Evening",
  category: "Urban"
},
{
  src: "/images/urban-flyover-street-scene.jpg",
  alt: "Urban Flyover Street Scene",
  category: "Urban"
},
{
  src: "/images/street-cat-portrait-golden-eyes-bokeh-night-photography-dhaka-mayachitro.jpg",
  alt: "Street Cat with Golden Eyes at Night in Dhaka",
  category: "Urban"
},
{
  src: "/images/street-dog-black-portrait-mayachitro.jpg",
  alt: "Black Street Dog Portrait",
  category: "Urban"
},


  // Macro
  {
    src: "/images/jumping-spider-on-green-leaf-macro-closeup-mayachitro.jpg",
    alt: "Jumping Spider Macro",
    category: "Macro"
  },
  {
    src: "/images/flying-black-butterfly-green-bokeh-background-macro-mayachitro.jpg",
    alt: "Flying Butterfly Macro",
    category: "Macro"
  },
  {
    src: "/images/yellow-wasp-macro-closeup-on-green-leaf-sharp-focus-nature-mayachitro.jpg",
    alt: "Yellow Wasp Macro",
    category: "Macro"
  },
  {
    src: "/images/water-droplets-on-leaf-closeup-macro-photography-green-texture-mayachitro.jpg",
    alt: "Water Droplets on Leaf",
    category: "Macro"
  },
  {
  src: "/images/macro-water-drops-on-leaf.jpg",
  alt: "Macro Water Drops on Leaf",
  category: "Macro"
},


  // Abstract
  {
    src: "/images/flame-and-frangipani-candlelight-dark-glow-mayachitro.jpg",
    alt: "Candlelight and Frangipani",
    category: "Abstract"
  },
  {
    src: "/images/flame-dance-fire-art-abstract-dark-background-mayachitro.jpg",
    alt: "Flame Dance Abstract",
    category: "Abstract"
  },
  {
    src: "/images/floating-frangipani-flowers-water-bowl-aesthetic-decor-mayachitro.jpg",
    alt: "Floating Frangipani Flowers",
    category: "Abstract"
  },
  {
  src: "/images/navy-warship-fishing-boat-silhouette-ocean-blue-seascape-contrast-mayachitro.jpg",
  alt: "Navy Warship and Fishing Boat Silhouette in Blue Seascape",
  category: "Abstract"
},


  // Architecture
  {
    src: "/images/golden-minarets-night-reflection-water-islamic-architecture-mayachitro.jpg",
    alt: "Golden Minarets Reflection",
    category: "Architecture"
  },
  {
    src: "/images/modern-architecture-golden-grid-facade-evening-sky-cloudscape-mayachitro.jpg",
    alt: "Modern Golden Grid Architecture",
    category: "Architecture"
  },
  {
    src: "/images/moonlit-bridge-cityscape-urban-night-lights-reflection-mayachitro.jpg",
    alt: "Moonlit Bridge Nightscape",
    category: "Architecture"
  },
  {
  src: "/images/romantic-crystal-glass-ball-light-art-handmade-souvenir-market-display-mayachitro.jpg",
  alt: "Romantic Crystal Glass Ball Light Art Display",
  category: "Abstract"
},
{
  src: "/images/victoria-memorial-dome-interior-statue-kolkata.jpg",
  alt: "Victoria Memorial Dome Interior with Statue in Kolkata",
  category: "Architecture"
},


  // Sky
  {
    src: "/images/full-moon-closeup-night-sky-lunar-surface-details-mayachitro.jpg",
    alt: "Full Moon Closeup",
    category: "Sunset"
  },
  {
    src: "/images/crescent-moon-under-branch-silhouette-evening-sky-frame-mayachitro.jpg",
    alt: "Crescent Moon Under Tree",
    category: "Sunset"
  },
  {
    src: "/images/horizontal-rainbow-halo-cloudscape-sky-art-mayachitro.jpg",
    alt: "Horizontal Rainbow Halo",
    category: "Sunset"
  },
  {
    src: "/images/moon-above-cumulus-cloud-blue-sky-minimalism-mayachitro.jpg",
    alt: "Moon Above Clouds",
    category: "Sunset"
  },
{
  src: "/images/stormy-sky-black-clouds-above-city-mayachitro.jpg",
  alt: "Stormy Sky with Black Clouds Over City",
  category: "Sunset"
},
{
  src: "/images/sunset-bird-flight.jpg",
  alt: "Bird Flying During Sunset over Horizon",
  category: "Sunset"
},
{
  src: "/images/biman-bangladesh-airlines-airplane-flying-sunset-sky-aviation-photography.jpg",
  alt: "Biman Bangladesh Airlines Flying Through Sunset Sky",
  category: "Sunset"
}

];

export default imageData;
